export default __webpack_public_path__ + "static/media/cut_quinten.6fb21025.png";